import permissions, { RESOURCE_ADMINISTRACION_PG } from '@/auth/permissions/modules/administracionPg'
import {
    ROUTE_CONFIGURACION_USUARIOS_COMPRAS,
    ROUTE_PERMISOS_ESTRUCTURA_ORGANIZACIONAL,
} from '@/router/routes/administracion-pg/nombres'
import { defineMenu } from '@/utils/menu'

const { configuracion } = permissions

export default defineMenu([
    {
        title: 'administracion.configuracion.usuarios_compras',
        resource: RESOURCE_ADMINISTRACION_PG,
        action: configuracion.usuariosCompras,
        route: ROUTE_CONFIGURACION_USUARIOS_COMPRAS,
    },
    {
        title: 'administracion-pg.subopciones.permisos_estructura_organizacional',
        resource: RESOURCE_ADMINISTRACION_PG,
        action: configuracion.permisosEstructuraOrganizacional,
        route: ROUTE_PERMISOS_ESTRUCTURA_ORGANIZACIONAL,
    },
])
